exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FixedContainer__container___1jOrc {\n  position: fixed;\n  background-color: #FFF;\n}\n\n.dark .FixedContainer__container___1jOrc {\n  background-color: #000;\n}", ""]);

// exports
exports.locals = {
	"container": "FixedContainer__container___1jOrc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/resolve-url-loader!./client/FixedContainer.css
// module id = 114
// module chunks = 0